import axios from "./axiosInstance";

const productAPI = {
  listing: (params) => axios.get(`products`, { params }),
  details: (slug) => axios.get(`products/${slug}`),
  filters: (params) => axios.get("products/filters", { params }),

  searchlisting: (params) => axios.get(`products/search-by-filters`, { params }),
};

export default productAPI;
